import { observer } from "mobx-react-lite";
import React, {Fragment, useState} from "react";
import {
  Col,
  Form,
  Modal,
  Row,
  Button,
  ConfigProvider,
  Table, Typography,
} from "antd";
import {CommonStore, LanguageManageStore} from "../../../store";
import "./index.css";
import dictionary from "../../../utils/dictionary";

function RowDetail() {
  const form = Form.useFormInstance();
  const { Column } = Table;
  const {Text } = Typography;

  return (
    <Fragment>
      <Modal
        width={"1000px"}
        centered
        title={"查看详情"}
        open={LanguageManageStore.detailModal.isOpen}
        destroyOnClose={true}
        onCancel={() => LanguageManageStore.detailModal.close()}
        footer={null}
        loading={LanguageManageStore.modalLoading}
      >
        <Form
          form={form}
          labelWrap
          labelCol={{ span: 8 }}
          style={{ marginTop: "20px" }}
          initialValues={LanguageManageStore.detailData}
        >
          <Row
            justify="start"
            style={{ maxHeight: "calc(75vh)", overflow: "auto" }}
          >
            <Col span={12}>
              <Form.Item label="话术ID">
                {LanguageManageStore.detailData.id}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="场景类型">
                {LanguageManageStore.detailData.sceneName}
              </Form.Item>
            </Col>
            <Col span={12}>
            <Form.Item label="合同链" >
              {LanguageManageStore.detailData.contractChain?.map(
                  (item: any, index: number) => (
                      <Text
                          style={{ width: "95%" }}
                          ellipsis={{tooltip: item.contractName}}
                      >
                        <Button
                            type="link"
                            onClick={() =>
                                LanguageManageStore.exportFile(item.objectName)
                            }
                            key={index}
                        >
                          {item.contractName}
                        </Button>
                      </Text>
                  )
              )}
            </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="到期时间">
                {LanguageManageStore.detailData.expireDate}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="创建人">
                {LanguageManageStore.detailData.createUser}
              </Form.Item>
            </Col>
            <Col span={24} >
              <Form.Item label="话术内容" labelCol={{ span: 4 }}>
                {LanguageManageStore.detailData.content}
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label="审核记录" labelCol={{ span: 4 }}>
                <ConfigProvider renderEmpty={CommonStore.tableEmptyRender}>
                  <Table
                      dataSource={LanguageManageStore.detailData.auditJournalList}
                      rowKey={(record) => record.auditTime}
                      scroll={{ x: 400 }}
                      pagination={false}
                  >
                    <Column
                        ellipsis={true}
                        width={120}
                        title="审核结果"
                        dataIndex="auditResult"
                        render={(auditResult) =>
                            dictionary.booleanResult.find((item: any) => item.value == auditResult)?.label
                        }
                    />
                    <Column
                        ellipsis={true}
                        width={120}
                        title="审核意见"
                        dataIndex="rejectedReason"
                    />
                    <Column
                        ellipsis={true}
                        width={100}
                        title="审核时间"
                        dataIndex="auditTime"
                    />
                  </Table>
                </ConfigProvider>
              </Form.Item>
            </Col>

          </Row>
        </Form>
      </Modal>
    </Fragment>
  );
}

export default observer(RowDetail);
